import { Component, Output, EventEmitter, OnInit } from '@angular/core';
import { ElectronicBillingSolicitateCAEService } from 'src/app/services/electronic-billing/solicitate-cae.service';

@Component({
  selector: 'app-solicitate-cae-dialog',
  templateUrl: './solicitate-cae-dialog.component.html',
  styleUrls: ['./solicitate-cae-dialog.component.scss']
})
export class SolicitateCaeDialogComponent implements OnInit {
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  value: any;
  loading = false;
  quantity: number = 0;
  total: number = 0;
  dialog1 = true;
  dialog2 = false;

  checkUser = true;
  checkAgent = true;

  constructor(private readonly solicitateCAE: ElectronicBillingSolicitateCAEService) { }

  ngOnInit(): void {
      if(this.value.dialog && this.value.dialog == 'first') {
        this.change.emit(this.value)
      } else {
        this.dialog1 = false;
        this.dialog2 = true;
        this.quantity = this.value.dto.comprobantesIds.length
        this.total = this.value.total;       
        this.postCAE(this.value.dto);
        this.change.emit('success')
      }
  }

  changeAgent(event:any) {
    this.value.dto.enviarMail = event.checked;
    this.change.emit(this.value)
  }

  changeUser(event:any) {
    this.value.dto.enviarCopia = event.checked;
    this.change.emit(this.value)
  }

  postCAE(dto:any) {
    this.solicitateCAE.post(dto, '')
  }
}
